import { render, staticRenderFns } from "./step_04.vue?vue&type=template&id=5ce3f193&scoped=true"
import script from "./step_04.vue?vue&type=script&lang=js"
export * from "./step_04.vue?vue&type=script&lang=js"
import style0 from "./step_04.vue?vue&type=style&index=0&id=5ce3f193&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce3f193",
  null
  
)

export default component.exports